import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { ICON } from '@core/util/icon';
import { MatterManualTitleInsurance } from '@models/title-insurance';
import { StewartStatus } from '@models/title-insurance/stewart';

export interface StewartCancelModalData {
	status: number;
}

@Component({
	selector: 'app-cancel-stewart-modal',
	templateUrl: './cancel-modal.component.html',
	standalone: false,
})
export class StewartCancelModalComponent {
	public StewartStatus = StewartStatus;
	public titleInsurance: MatterManualTitleInsurance;
	public submitted = false;
	public status: number;

	public ICON = ICON;

	@ViewSelectSnapshot(SelectedMatter.closingDate) closingDate: string;

	constructor(
		private dialogRef: MatDialogRef<StewartCancelModalComponent>,
		@Inject(MAT_DIALOG_DATA) public _data: StewartCancelModalData,
	) {
		this.status = _data.status;
	}

	cancel() {
		this.dialogRef.close(true);
	}

	close() {
		this.dialogRef.close(false);
	}
}
